import React, { useEffect, useState, useRef } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { CFooter, CNav, CNavItem, CNavLink } from '@coreui/react-pro'
import CIcon from '@coreui/icons-react'
import {
  cilHome,
  cilList,
  cilShieldAlt,
  cilMap,
  cilPhone,
  cilPen,
  cilInfo,
  cilLocationPin,
} from '@coreui/icons'

import * as cusUtil from 'src/viewsCommon/CusUtil'

const AppFooter = (param) => {
  const cid = cusUtil.getCid()

  const AppFooterUser = require('src/viewsCus/_company/menu/' +
    cid +
    '/AppFooterUser_' +
    cid).default

  return <AppFooterUser />
}

export default React.memo(AppFooter)
